import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_picking_to_packing_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    src_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_list_hdr_running_no: fromDatatype.VarcharDatatypeInterface;
    src_gendoc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    src_gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    descr : fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
}


export class bl_wms_picking_to_packing_link_RowClass
    implements bl_wms_picking_to_packing_link_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
        packing_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
        src_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
        packing_list_hdr_running_no: fromDatatype.VarcharDatatypeInterface;
        src_gendoc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
        src_gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
        descr : fromDatatype.VarcharDatatypeInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VrsnDataFieldInterface;
        property_json: fromDatatype.JsonDatatypeInterface;
        namespace: fromDatatype.VarcharDatatypeInterface;
        acl_config: fromDatatype.JsonDatatypeInterface;
        acl_policy: fromDatatype.JsonDatatypeInterface;
        status: fromDatatype.StatusDataFieldInterface;
}